import { render, staticRenderFns } from "./general-journal-record-v3.vue?vue&type=template&id=4b0e4d95&scoped=true&"
import script from "./general-journal-record-v3.vue?vue&type=script&lang=js&"
export * from "./general-journal-record-v3.vue?vue&type=script&lang=js&"
import style0 from "./general-journal-record-v3.vue?vue&type=style&index=0&id=4b0e4d95&scoped=true&lang=css&"
import style1 from "./general-journal-record-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e4d95",
  null
  
)

export default component.exports